       <template>
  <div class="app-change-payment-wrapper">
    <slot name="txtBeforeChangePayment"></slot>
    <ChangePaymentViewWrapper v-if="showView" nextStep=changeStepName>
      <template #lblPaymentType><slot name="lblViewPaymentType"></slot></template>
      <template #txtNoPayment><slot name="txtViewNoPayment"></slot></template>
      <template #txtCreditCard><slot name="txtViewCreditCard"></slot></template>
      <template #txtBankAccount><slot name="txtViewBankAccount"></slot></template>
      <template #txtBeforePayment><slot name="txtViewBeforePayment"></slot></template>
      <template #txtBeforeCreditCardPayment><slot name="txtViewBeforeCreditCardPayment"></slot></template>
      <template #lblCcHolderCreditCardPayment><slot name="lblViewCcHolderCreditCardPayment"></slot></template>
      <template #lblCcNumberCreditCardPayment><slot name="lblViewCcNumberCreditCardPayment"></slot></template>
      <template #lblCcTypeCreditCardPayment><slot name="lblViewCcTypeCreditCardPayment"></slot></template>
      <template #lblCcValidtyCreditCardPayment><slot name="lblViewCcValidtyCreditCardPayment"></slot></template>
      <template #txtAfterCreditCardPayment><slot name="txtViewAfterCreditCardPayment"></slot></template>
      <template #txtErrorCreditCardPayment><slot name="txtViewErrorCreditCardPayment"></slot></template>
      <template #txtBeforeBankAccountPayment><slot name="txtViewBeforeBankAccountPayment"></slot></template>
      <template #lblOwnerBankAccountPayment><slot name="lblViewOwnerBankAccountPayment"></slot></template>
      <template #lblIbanBankAccountPayment><slot name="lblViewIbanBankAccountPayment"></slot></template>
      <template #txtAfterBankAccountPayment><slot name="txtViewAfterBankAccountPayment"></slot></template>
      <template #txtAfterPayment><slot name="txtViewAfterPayment"></slot></template>
      <template #btnNext><slot name="btnNextView"></slot></template>
    </ChangePaymentViewWrapper>
    <ChangePaymentChangeWrapper
      v-if="showChange"
      nextStep=successStepName
      :credit-card-frame-address="creditCardFrameAddress"
      :credit-card-redirect-url="creditCardRedirectUrl"
    >
      <template #txtBeforeChangePayment><slot name="txtChangeBeforeChangePayment"></slot></template>
      <template #txtPaymentBeforePayment><slot name="txtChangePaymentBeforePayment"></slot></template>
      <template #lblPaymentCreditCard><slot name="lblChangePaymentCreditCard"></slot></template>
      <template #txtPaymentCcBefore><slot name="txtChangePaymentCcBefore"></slot></template>
      <template #txtPaymentCcInfoBefore><slot name="txtChangePaymentCcInfoBefore"></slot></template>
      <template #lblPaymentCcInfoCcHolder><slot name="lblChangePaymentCcInfoCcHolder"></slot></template>
      <template #lblPaymentCcInfoCcNumber><slot name="lblChangePaymentCcInfoCcNumber"></slot></template>
      <template #lblPaymentCcInfoCcType><slot name="lblChangePaymentCcInfoCcType"></slot></template>
      <template #lblPaymentCcInfoCcValidty><slot name="lblChangePaymentCcInfoCcValidty"></slot></template>
      <template #txtPaymentCcInfoAfter><slot name="txtChangePaymentCcInfoAfter"></slot></template>
      <template #txtPaymentCcInfoError><slot name="txtChangePaymentCcInfoError"></slot></template>
      <template #btnPaymentCcRestart><slot name="btnChangePaymentCcRestart"></slot></template>
      <template #txtPaymentCcAfter><slot name="txtChangePaymentCcAfter"></slot></template>
      <template #lblPaymentBankAccount><slot name="lblChangePaymentBankAccount"></slot></template>
      <template #lblPaymentBankAccountOwner><slot name="lblChangePaymentBankAccountOwner"></slot></template>
      <template #lblPaymentBankAccountIban><slot name="lblChangePaymentBankAccountIban"></slot></template>
      <template #txtPaymentBankAccountIbanLiveFeedback><slot name="txtChangePaymentBankAccountIbanLiveFeedback"></slot></template>
      <template #lblPaymentBankAccountPaymentConfirmation><slot name="lblChangePaymentBankAccountPaymentConfirmation"></slot></template>
      <template #btnNext><slot name="btnNextChange"></slot></template>
      <template #btnPrev><slot name="btnPrevChange"></slot></template>
    </ChangePaymentChangeWrapper>
    <Success
      v-if="showSuccess"
      nextStep=viewStepName
      :back="backToView"
    >
      <template #txtBefore><slot name="txtSuccessBefore"></slot></template>
      <template #btnSuccessBack><slot name="btnSuccessBack"></slot></template>
      <template #txtAfter><slot name="txtSuccessAfter"></slot></template>
    </Success>
  </div>
</template>
<script>
import ChangePaymentViewWrapper, { stepName as viewStepName } from './ViewWrapper.vue'
import ChangePaymentChangeWrapper, { stepName as changeStepName } from './ChangeWrapper.vue'
import Success, { stepName as successStepName } from '../../../../generic/Success2.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'ChangePaymentWrapper',
  components: { Success, ChangePaymentChangeWrapper, ChangePaymentViewWrapper },
  mixins: [
    transaction('changePayment')
  ],
  methods: {
    ...mapMutations('changePayment', [
      'changeStep'
    ]),
    backToView () {
      this.changeStep({ step: viewStepName })
    }
  },
  computed: {
    ...mapGetters('changePayment', [
      'currentStep'
    ]),
    showView () {
      return this.currentStep === viewStepName
    },
    showChange () {
      return this.currentStep === changeStepName
    },
    showSuccess () {
      return this.currentStep === successStepName
    }
  },
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    }
  }
}
</script>
